<template>

    <div class="container">
        <div
            v-if="co === false"
        >
            <div class="col-6 offset-3">
                <div class="alert alert-info">
                    <h2 style="font-size:1.1rem !important;">{{ lang('all.niet_mogelijk_om_af_te_rekenen') }}</h2>
                    <p>{{ lang('all.de_accountgegevens_zijn_niet_volledig_ingevoerd') }}</p>
                    <p>{{ lang('all.voeg_eerst_producten_toe_aan_de_winkelwagen_voorda') }}</p>
                    <inertia-link
                        :href="route('auth.myaccount.details.index')"
                        class="btn btn-primary btn-sm"
                    >
                        {{ lang('all.accountgegevens_invullen') }}
                    </inertia-link>
                </div>
            </div>
        </div>

        <div
            v-else-if="cart.count === 0 || products.length === 0"
        >
            <div class="col-6 offset-3">
                <div class="alert alert-info">
                    <h2 style="font-size:1.1rem !important;">{{ lang('all.niet_mogelijk_om_af_te_rekenen') }}</h2>
                    <p>{{ lang('all.er_zijn_geen_producten_toegevoegd_aan_de_winkelwag') }}</p>
                    <p class="mb-0">{{ lang('all.voeg_eerst_producten_toe_aan_de_winkelwagen_voorda') }}</p>
                </div>
            </div>
        </div>

        <div class="checkout"
            v-else
        >
            <wizard
                :show-actions="false"
                :steps="steps"
                ref="wizard"
            >
                <div slot="addresses">
                    <h2>{{ lang('all.factuuradres') }}</h2>

                    <div class="row checkout-addresses">
                        <div class="col-3">
                            <address class="selected">
                                <label style="cursor:default !important;">
                                    <span v-html="formatAddr(billingaddress.data)"></span>
                                </label>
                            </address>
                        </div>
                    </div>

                    <div>
                        <label>
                            <input
                                type="checkbox"
                                v-model="shippingaddressTheSame"
                            />
                            {{ lang('all.het_bezorgadres_is_hetzelfde_als_mijn_factuuradres') }}
                        </label>
                    </div>

                    <div
                        v-if="!shippingaddressTheSame"
                    >
                        <h2>{{ lang('all.bezorgadres') }}</h2>
                        <p v-if="addresses.data.length > 0">{{ lang('all.selecteer_hieronder_het_bezorgadres_voor_deze_best') }}</p>
                        <p v-else>{{ lang('all.er_zijn_nog_geen_adressen_ingesteld_in_dit_account') }}</p>
                        <inertia-link
                            :href="route('auth.myaccount.addresses.create')"
                            class="btn btn-primary btn-sm"
                            v-if="addresses.data.length === 0"
                        >{{ lang('all.voeg_een_nieuw_adres_toe') }}</inertia-link>

                        <div class="row checkout-addresses">
                            <div class="col-3"
                                 v-for="address in addresses.data"
                            >
                                <address
                                    :class="{'selected':form.shipping === address.uuid}"
                                >
                                    <label
                                        :for="'shippingradio-' + address.uuid"
                                    >
                                        <input
                                            :id="'shippingradio-' + address.uuid"
                                            type="radio"
                                            name="shippingaddress"
                                            v-model="form.shipping"
                                            :value="address.uuid"
                                        />
                                        <span v-html="formatAddr(address)"></span>
                                    </label>
                                </address>
                            </div>
                        </div>
                    </div>

                    <div class="text-right">
                        <button
                            class="btn btn-primary"
                            :disabled="!canGoToShippingmethod"
                            @click="addressesSelected"
                        >
                            {{ lang('all.naar_neklabel') }}
                            <i class="mdi mdi-chevron-right"></i>
                        </button>
                    </div>
                </div>
                <div slot="necktag">
                    <div class="row">
                        <div class="col-6">
                            <h2>{{ lang('all.neklabel') }}</h2>
                            <p v-if="ntrequired">{{ lang('all.neklabel_checkout_beschrijving', {'%necktagtotalprice%': toCurrency(necktag.data.price)})}}</p>
                            <p v-else>{{ lang('all.neklabel_checkout_beschrijving_notrequired', {'%necktagtotalprice%': toCurrency(necktag.data.price)})}}</p>
                            <yes-no-radio
                                v-model="form.ownnecktag"
                                :label="lang('all.eigen_neklabel_gebruiken')"
                                :trans="necktagTrans"
                            ></yes-no-radio>
                        </div>
                        <div class="col-6" v-html="lang('all.neklabel_long_desc')"></div>
                    </div>


                    <div class="text-right">
                        <button
                            class="btn btn-primary"
                            :disabled="!canGoToShippingmethod"
                            @click="necktagSelected"
                        >
                            {{ lang('all.naar_bezorging') }}
                            <i class="mdi mdi-chevron-right"></i>
                        </button>
                    </div>
                </div>
                <div slot="shippingmethod">
                    <h2>{{ lang('all.bezorging') }}</h2>
                    <div
                        v-if="fetchingShippingmethods"
                        class="text-center mt-5 mb-5"
                    >
                        <loading></loading>
                        <p>{{ lang('all.bezorgwijzen_ophalen') }}</p>
                    </div>
                    <div
                        v-else
                    >
                        <p>{{ lang('all.selecteer_hieronder_de_gewenste_bezorging') }}</p>
                        <table class="table table-striped table-hover">
                            <tbody>
                            <tr
                                v-for="shippingmethod in shippingmethods"
                            >
                                <td>
                                    <h3>{{ shippingmethod.name }}</h3>
                                </td>
                                <td>
                                    <p v-html="shippingmethod.description"></p>
                                </td>
                                <td class="text-right">
                                    {{ shippingmethod.price | toCurrency }}
                                </td>
                                <td class="text-right">
                                    <button
                                        class="btn btn-primary btn-sm mb-0"
                                        @click="selectShippingmethod(shippingmethod)"
                                        style="min-width:150px;"
                                    >
                                        {{ lang('all.selecteer') }}
                                        <i class="mdi mdi-chevron-right"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div slot="paymentmethod">
                    <h2>{{ lang('all.betaalwijze') }}</h2>
                    <div
                        v-if="fetchingPaymentmethods"
                        class="text-center mt-5 mb-5"
                    >
                        <loading></loading>
                        <p>{{ lang('all.betaalwijzen_ophalen') }}</p>
                    </div>
                    <div
                        v-else
                    >
                        <p>{{ lang('all.selecteer_hieronder_de_gewenste_betaalwijze') }}</p>
                        <table class="table table-striped table-hover">
                            <tbody>
                                <tr
                                    v-for="paymentmethod in paymentmethods"
                                    :key="paymentmethod.uuid"
                                >
                                    <td>
                                        <h3
                                            :class="{
                                                'paymentmethod': true,
                                                'strikethrough': paymentmethod.canUse === false
                                            }"
                                        >{{ paymentmethod.name }}</h3>
                                    </td>
                                    <td>
                                        <p
                                            :class="{'strikethrough mb-1': paymentmethod.canUse === false}"
                                            v-html="paymentmethod.description"
                                        />
                                        <p
                                            v-if="paymentmethod.canUse === false"
                                            class="mb-1"
                                            v-html="lang('checkout.disabled', {'%maximumAmount%': toCurrency(paymentmethod.maximumAmount)})"
                                        />
                                    </td>
                                    <td
                                        :class="{
                                            'text-right': true,
                                            'strikethrough': paymentmethod.canUse === false
                                        }"
                                    >
                                        {{ paymentmethod.price | toCurrency }}
                                    </td>
                                    <td class="text-right">
                                        <button
                                            class="btn btn-primary btn-sm mb-0"
                                            @click="selectPaymentmethod(paymentmethod)"
                                            style="min-width:150px;"
                                            :disabled="paymentmethod.canUse === false"
                                        >
                                            {{ lang('all.selecteer') }}
                                            <i class="mdi mdi-chevron-right"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div slot="overview">
                    <h2>{{ lang('all.overzicht') }}</h2>
                    <div class="row">
                        <div class="col-md-6">
                            <table class="table" v-if="selectedShippingmethod !== null && selectedPaymentmethod !== null">
                                <tbody>
                                    <tr>
                                        <th>{{ lang('all.bezorging') }}</th>
                                        <td>
                                            <strong>{{ selectedShippingmethod.name }}</strong>
                                            <p
                                                class="mb-0"
                                                v-html="selectedShippingmethod.description"
                                            ></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ lang('all.betaalwijze') }}</th>
                                        <td>
                                            <strong>{{ selectedPaymentmethod.name }}</strong>
                                            <p
                                                class="mb-0"
                                                v-html="selectedPaymentmethod.description"
                                            ></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="!shippingaddressTheSame">{{ lang('all.facturatieadres') }}</th>
                                        <th v-else>{{ lang('all.facturatie_en_bezorgadres') }}</th>
                                        <td v-html="formatAddr(billingaddress.data)"></td>
                                    </tr>
                                    <tr v-if="!shippingaddressTheSame">
                                        <th>{{ lang('all.bezorgadres') }}</th>
                                        <td v-html="formatAddr(selectedShippingAddress)"></td>
                                    </tr>
                                    <tr v-if="notax === true">
                                        <th>{{ lang('all.btw_verlegd') }}</th>
                                        <td>{{ taxnumber }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <checkbox-input
                                v-model="form.tac"
                                class="mb-2"
                            >
                                {{ lang('all.ik_ga_akkoord_met_de') }} <a target="_blank" href="/algemene-voorwaarden">{{ lang('all.algemene_voorwaarden') }}</a>
                            </checkbox-input>

                            <checkbox-input
                                v-model="form.paymentobligation"
                                class="mb-4"
                                :label="lang('all.hiermee_bevestig_ik_dat_ik_een_betalingsverplichti')"
                            ></checkbox-input>

                            <div class="text-right">
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    :disabled="!canSubmit"
                                    @click="onSubmit"
                                >
                                    {{ lang('all.betalen') }}
                                    <i class="mdi mdi-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <h3>{{ lang('all.geselecteerde_producten') }}</h3>
                            <table class="table table-striped">
                                <tbody>
                                    <tr
                                        v-for="product in products"
                                        class="checkout-product"
                                    >
                                        <td>
                                            <inertia-link
                                                :href="route('products.item', {brand_slug:product.product.brand_slug, slug:product.product.slug})"
                                            >
                                                <img
                                                    :src="product.product.image.url"
                                                    :alt="product.product.image.name"
                                                    class="thumbnail"
                                                />
                                            </inertia-link>
                                        </td>
                                        <td>
                                            <h3>
                                                <inertia-link
                                                    :href="route('products.item', {brand_slug:product.product.brand_slug, slug:product.product.slug})"
                                                >
                                                    {{ product.product.name }}
                                                </inertia-link>
                                            </h3>

                                            <p>{{ product.quantity }}x &aacute; {{ product.product.price | toCurrency }}</p>
                                        </td>
                                        <td class="text-right">{{ (product.quantity * product.product.price) | toCurrency }}</td>
                                    </tr>
                                    <tr v-if="form.ownnecktag === true">
                                        <td>&nbsp;</td>
                                        <td>Eigen neklabel ({{ necktagTotalProductQuantity }})</td>
                                        <td class="text-right">{{ necktagSubTotal | toCurrency }}</td>
                                    </tr>
                                    <tr v-if="selectedPaymentmethod !== null">
                                        <td>&nbsp;</td>
                                        <td>{{ lang('all.betaalwijze2', {'%name%': selectedPaymentmethod.name}) }}</td>
                                        <td class="text-right">{{ selectedPaymentmethod.price | toCurrency }}</td>
                                    </tr>
                                    <tr v-if="selectedShippingmethod !== null">
                                        <td>&nbsp;</td>
                                        <td>{{ lang('all.verzendwijze2', {'%name%': selectedShippingmethod.name}) }}</td>
                                        <td class="text-right">{{ selectedShippingmethod.price | toCurrency }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="cart-subtotal">
                                        <td>&nbsp;</td>
                                        <th class="text-right">{{ lang('all.subtotaal') }}</th>
                                        <td class="text-right">
                                            {{ grandSubTotal | toCurrency }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-for="(taxtotal, taxrate) in grandTaxes"
                                    >
                                        <td>&nbsp;</td>
                                        <th class="text-right">{{ lang('all.btw', {'%taxrate%': taxrate}) }}</th>
                                        <td class="text-right">
                                            {{ lang('all.key', {'%toCurrency%': toCurrency(taxtotal) }) }}
                                        </td>
                                    </tr>
                                    <tr class="order-total">
                                        <td>&nbsp;</td>
                                        <th class="text-right">{{ lang('all.totaal2') }}</th>
                                        <td class="text-right">
                                            {{ grandTotal | toCurrency }}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </wizard>
        </div>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";
import BaseCart from "../../../components/Cart/BaseCart";
import CheckboxInput from "../../../Common/CheckboxInput";
import Wizard from "../../../Libraries/Wizard";
import FormatAddress from "../../../Libraries/FormatAddress";
import Loading from '../../../components/Loading';
import axios from "axios";
import YesNoRadio from "../../../Common/YesNoRadio";
import toCurrency from "../../../filters/toCurrency";
import {mapActions} from "vuex";

export default {

    components: {
        CheckboxInput,
        Wizard,
        Loading,
        YesNoRadio,
    },

    computed: {
        canGoToShippingmethod() {
            return this.shippingaddressTheSame === true || !!this.form.shipping;
        },

        grandSubTotal() {
            let subtotal = this.subTotal;
            subtotal += this.necktagSubTotal;

            if (this.selectedPaymentmethod !== null) {
                subtotal += this.selectedPaymentmethod.price;
            }

            if (this.selectedShippingmethod !== null) {
                subtotal += this.selectedShippingmethod.price;
            }

            return subtotal;
        },

        grandTaxes() {
            if (this.notax === true) {
                return {0: 0};
            }

            let taxes = JSON.parse(JSON.stringify(this.taxes));

            if (this.necktagTotalProductQuantity > 0 && this.form.ownnecktag === true) {
                taxes[this.necktag.data.taxrate] += this.necktagTotalProductQuantity * (Math.round((this.necktag.data.price / 100) * this.necktag.data.taxrate));
            }

            if (this.selectedPaymentmethod !== null) {
                if (!taxes[this.selectedPaymentmethod.taxrate]) {
                    taxes[this.selectedPaymentmethod.taxrate] = 0;
                }

                taxes[this.selectedPaymentmethod.taxrate] += Math.round((this.selectedPaymentmethod.price / 100) * this.selectedPaymentmethod.taxrate);
            }

            if (this.selectedShippingmethod !== null) {
                if (!taxes[this.selectedShippingmethod.taxrate]) {
                    taxes[this.selectedShippingmethod.taxrate] = 0;
                }

                taxes[this.selectedShippingmethod.taxrate] += Math.round((this.selectedShippingmethod.price / 100) * this.selectedShippingmethod.taxrate);
            }

            return taxes;
        },

        grandTaxTotal() {
            let total = 0;
            Object.values(this.grandTaxes).forEach(inc => total += inc);
            return total;
        },

        grandTotal() {
            return this.grandSubTotal + this.grandTaxTotal;
        },

        canSubmit() {
            return (this.shippingaddressTheSame === true || this.form.shipping !== null) &&
                this.form.paymentmethod !== null &&
                this.form.shippingmethod !== null &&
                this.form.tac === true &&
                this.form.paymentobligation === true &&
                this.posting === false;
        },

        necktagTotalProductQuantity() {
            let quantity = 0;

            this.products.forEach(product => quantity += product.quantity);

            return quantity;
        },

        necktagTrans() {
            return {
                yes: this.lang('global.yes') + ' (' + toCurrency(this.necktagSubTotalPrice) + ')',
                no: this.lang('global.no'),
            }
        },

        necktagSubTotal() {
            if (this.necktagTotalProductQuantity < 1 || this.form.ownnecktag === false) {
                return 0;
            }

            return this.necktagSubTotalPrice;
        },

        necktagSubTotalPrice() {
            return this.necktag.data.price * this.necktagTotalProductQuantity;
        },

        postData() {
            return {
                necktag:this.form.ownnecktag,
                shipping_address:this.form.shipping,
                paymentmethod_id:this.form.paymentmethod,
                shippingmethod_id:this.form.shippingmethod,
            };
        },

        selectedPaymentmethod() {
            if (this.form.paymentmethod === null) {
                return null;
            }

            let paymentmethod = this.paymentmethods.filter(paymentmethod => paymentmethod.uuid === this.form.paymentmethod);

            return paymentmethod.length === 1 ?
                paymentmethod[0] :
                null;
        },

        selectedShippingAddress() {
            if (this.shippingaddressTheSame === true) {
                return this.billingaddress.data;
            }

            if (this.form.shipping === null) {
                return null;
            }

            let address = this.addresses.data.filter(addr => addr.uuid === this.form.shipping);

            return address.length === 1 ?
                address[0] :
                null;
        },

        selectedShippingmethod() {
            if (this.form.shippingmethod === null) {
                return null;
            }

            let shippingmethod = this.shippingmethods.filter(shippingmethod => shippingmethod.uuid === this.form.shippingmethod);

            return shippingmethod.length === 1 ?
                shippingmethod[0] :
                null;
        },

        subTotalIncludingShipping() {
            let subtotal = this.subTotal;

            if (this.selectedShippingmethod) {
                subtotal += this.selectedShippingmethod.price;
            }

            return subtotal;
        },
    },

    data() {
        return {
            fetchingPaymentmethods:true,
            fetchingShippingmethods:true,
            form: {
                billing:null,
                shipping:null,
                paymentmethod:null,
                shippingmethod:null,
                ownnecktag:false,
                tac:false,
                paymentobligation:false,
            },
            paymentmethods:[],
            posting: false,
            shippingaddressTheSame:true,
            shippingmethods:[],
            steps: [
                {
                    label: this.lang('all.checkout_gegevens'),
                    slot: 'addresses',
                },
                {
                    label: this.lang('all.checkout_necktag'),
                    slot: 'necktag',
                },
                {
                    label: this.lang('all.checkout_bezorging'),
                    slot: 'shippingmethod',
                },
                {
                    label: this.lang('all.checkout_betaalwijze'),
                    slot: 'paymentmethod',
                },
                {
                    label: this.lang('all.checkout_overzicht'),
                    slot: 'overview',
                },
                {
                    label: this.lang('all.checkout_betalen'),
                    slot: 'pay',
                },
            ],
        }
    },

    extends:BaseCart,

    layout:Layout,

    metaInfo: {
        title:'Afrekenen',
    },

    methods: {
        ...mapActions([
            'fetchCart',
        ]),

        addressesSelected() {
            this.getShippingmethods();
            this.$refs.wizard.goNext();
        },

        formatAddr(address) {
            if (address === null) {
                return '';
            }
            return FormatAddress(address);
        },

        getPaymentmethods() {
            this.fetchingPaymentmethods = true;
            axios.post(this.route('api.v1.paymentmethods.index'), {
                locale: this.$page.props.locale.current,
                subtotal: this.subTotalIncludingShipping,
            }).then(resp => {
                this.paymentmethods = resp.data;
                this.fetchingPaymentmethods = false;
            });
        },

        getShippingmethods() {
            this.fetchingShippingmethods = true;
            axios.post(this.route('api.v1.shippingmethods.index'), {
                boxes: this.boxes,
                country: this.selectedShippingAddress.country_id,
                locale: this.$page.props.locale.current,
            }).then(resp => {
                this.shippingmethods = resp.data;
                this.fetchingShippingmethods = false;
            });
        },

        necktagSelected() {
            this.$refs.wizard.goNext();
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.$GA4.dispatch('purchase');
            this.posting = true;

            this.$inertia.post(this.route('auth.checkout.store'), this.postData, {
                onFinish: () => {
                    this.posting = false;
                    this.fetchCart();
                },
            });
        },

        selectShippingmethod(shippingmethod) {
            this.$GA4.dispatch('add_shipping_info');
            this.form.shippingmethod = shippingmethod.uuid;
            this.getPaymentmethods();
            this.$refs.wizard.goNext();
        },

        selectPaymentmethod(paymentmethod) {
            if (paymentmethod.canUse === false) {
                return;
            }

            this.$GA4.dispatch('add_payment_info');
            this.form.paymentmethod = paymentmethod.uuid;
            this.$refs.wizard.goNext();
        },

        toCurrency(cur) {
            return toCurrency(cur);
        },
    },

    mounted(){
        this.$GA4.dispatch('begin_checkout');

        if (this.defaultaddresses.shipping) {
            this.form.shipping = JSON.parse(JSON.stringify(this.defaultaddresses.shipping));
        }
        if (!!this.form.billing && !!this.form.shipping && this.form.billing !== this.form.shipping) {
            this.shippingaddressTheSame = false;
        }
        if (this.paymentmethods.length === 1) {
            this.form.paymentmethod = this.paymentmethods[0].uuid;
        }
        if (this.shippingmethods.length === 1) {
            this.form.shippingmethod = this.shippingmethods[0].uuid;
        }
    },

    name:'AuthCheckoutIndex',

    props: {
        addresses: {
            type:Object,
            required:true,
        },
        billingaddress: {
            type:Object,
            requiredl:true,
        },
        boxes: {
            type:Number,
            required:true,
        },
        co: {
            type:Boolean,
            required:true,
        },
        defaultaddresses: {
            type:Object,
            required:true,
        },
        necktag: {
            required:true,
            type:Object,
        },
        notax: {
            required:true,
            type:Boolean,
            default:false,
        },
        ntrequired: {
            required:true,
            type:Boolean,
            default:true,
        },
        taxnumber: {
            type:String,
            default:null,
        },
    },

    watch: {
        shippingaddressTheSame: function (newValue) {
            if (newValue === true) {
                this.form.shipping = JSON.parse(JSON.stringify(this.form.billing));
            } else {
                if (this.form.shipping === this.form.billing) {
                    this.form.shipping = null;
                }
            }
        },
    },

}

</script>
